import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useRef } from 'react';
import { InputMask } from '@react-input/mask';
import { useStyles } from './styles';
export const FlightMaskedInput = memo(({ value, label, placeholder, mask, replacement, inputRef, invalid, isActive, showMask, separate, inputMode = 'text', postfix, onFieldPointerDown, onFocus, onBlur, onClick, onPointerDown, onPointerUp, onSelect, onChange, onKeyDown, }) => {
    const classes = useStyles();
    const lastPointerTypeRef = useRef(null);
    const handleFieldPointerDown = (event) => {
        onFieldPointerDown?.(event);
    };
    const handleFieldClick = (event) => {
        const target = event.target;
        if (target.closest('button, [role="button"]')) {
            return;
        }
        inputRef.current?.focus();
    };
    const handleInputFocus = (event) => {
        onFocus?.(event);
    };
    const handleInputBlur = (event) => {
        onBlur?.(event);
    };
    const handleInputClick = (event) => {
        event.stopPropagation();
        onClick?.(event);
    };
    const handleInputPointerUp = (event) => {
        onPointerUp?.(event);
    };
    const handleInputPointerDown = (event) => {
        lastPointerTypeRef.current = event.pointerType;
        onPointerDown?.(event);
    };
    const handleInputSelect = (event) => {
        onSelect?.(event);
    };
    const handleInputKeyDown = (event) => {
        onKeyDown?.(event);
    };
    const handleInputContextMenu = (event) => {
        if (lastPointerTypeRef.current === 'mouse') {
            event.preventDefault();
        }
    };
    return (_jsxs("div", { className: classes.field, "data-active": Boolean(isActive), "data-invalid": Boolean(invalid), onPointerDown: handleFieldPointerDown, onClick: handleFieldClick, role: "group", "aria-label": label, children: [_jsx("span", { className: classes.label, "data-active": Boolean(isActive), "data-hasvalue": Boolean(value), children: label }), _jsx(InputMask, { ref: inputRef, className: classes.input, style: {
                    '--flight-mask-length': mask.length,
                }, value: value, mask: mask, replacement: replacement, showMask: showMask, separate: separate, placeholder: isActive || value ? placeholder : '', inputMode: inputMode, autoComplete: "off", "aria-label": label, "data-active": Boolean(isActive), "data-hasvalue": Boolean(value), onFocus: handleInputFocus, onBlur: handleInputBlur, onClick: handleInputClick, onPointerDown: handleInputPointerDown, onPointerUp: handleInputPointerUp, onSelect: handleInputSelect, onChange: onChange, onKeyDown: handleInputKeyDown, onContextMenu: handleInputContextMenu }), postfix && (_jsx("span", { className: classes.postfixWrapper, children: postfix }))] }));
});
